import { readNotesTable } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasNotesLocalDatabaseContentType, NoteId } from '../../types/notes';

type NoteType = {
  note_id: NoteId;
};

export const checkNotesLocalDatabaseContent = async () => {
  console.log('hasNotesLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasNotesLocalDatabaseContent = false as HasNotesLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasNotesLocalDatabaseContent: hasNotesLocalDatabaseContent,
    };
  }

  try {
    const notesLocalDatabaseContent = await readNotesTable({ ownerId });
    logger.debug(notesLocalDatabaseContent, 'Local database content FOUND');
    const notesObject: { [key: string]: NoteType } = {};
    notesLocalDatabaseContent.forEach((element: NoteType) => {
      notesObject[element.note_id] = element;
    });
    // Fix: notesLocalDatabaseContent is an array, so check .length, not Object.keys().length
    const hasNotes = Boolean(notesLocalDatabaseContent && notesLocalDatabaseContent.length > 0);
    return {
      notes: notesObject,
      hasNotesLocalDatabaseContent: hasNotes,
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      hasNotesLocalDatabaseContent: false,
    };
  }
};
